<template>
  <img class="wave-bg" src="https://beneflex-icons.s3.amazonaws.com/clients/barra-login.svg" />
</template>

<script>
export default {
  name: "welcomeComponent",
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>

body {
  font-family: 'Nunito Sans', sans-serif;
}

.wave-bg {
  position: relative;
  height: 100vh;
}

@media screen and (max-width: 1000px) {
  .wave-bg{
  display:none;
  }
}

</style>
